import { Divider, Typography } from '@mui/material';
import { useStyles } from './DataRow.styles';

interface Props {
  label?: React.ReactNode;
  children: React.ReactNode;
  action?: React.ReactNode;
  divider?: boolean;
}

const DataRow = (props: Props) =>{
  const classes = useStyles();
  return (
    <>
      <div className={classes.root}>
        <Typography
          variant="overline"
          color="textSecondary"
          className={classes.label}
          role="tr"
          component="div"
        >
          {props.label}
        </Typography>
        <div className={classes.content} style={{minWidth: props.action ? '30%' : '70%'}}>{props.children}</div>
        {!!props.action && props.action}
      </div>
      {props.divider && <Divider className={classes.divider} />}
    </>
  );
}

export default DataRow;
